<template>
  <div class="home">
    <van-nav-bar
        title="峪森物联网卡信息查询"
    />
    <div class="main-panel">
    <van-form @submit="onSubmit">
<!--      <van-field
          v-model="nickname"
          label="姓名"
          required
          placeholder="姓名"
          :rules="[{ required: true, message: '请填写用户名' }]"
      />-->
      <van-field
          v-model="mobile"
          type="tel"
          label="手机号"
          required
          placeholder="手机号"
          :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <div style="margin: 16px;">
        <van-button block type="info" native-type="submit" loading-text="正在处理" :loading="isLoading" >查询</van-button>
      </div>
    </van-form>
      <div class="devicecard-list-panel">
        <div v-for="device in deviceCardList" :key="device.id" class="devicecard">
          <div><span class="mlabel">物联网卡号</span><span>{{device.cardId}}</span></div>
          <div><span class="mlabel">有效日期</span><span>{{formatTime(device.cardBindTime)}} 至 {{formatTime(device.cardExpriedTime)}}</span></div>
          <div><span class="mlabel">设备信息</span><span>{{device.deviceName}}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getByMobile} from "@/api/member"
import {getListByMid} from "@/api/deviceCard";
import {Toast} from "vant";
import * as dayjs from 'dayjs'

export default {
  name: 'HomeView',
  components: {
  },
  data(){
    return {
      isLoading:false,
      nickname: '',
      mobile: '',

      deviceCardList:[],
    }
  },
  methods:{
    onSubmit() {
      this.isLoading = true
      this.deviceCardList = []
      getByMobile(this.mobile).then(res=>{
        if(res.data == -1){
          this.isLoading=false
          Toast.fail("未能查到相关数据！")
        }else{
          getListByMid(res.data).then(res=>{
            this.deviceCardList= res.data
            this.isLoading=false
            if(this.deviceCardList.length<1){
              Toast.fail("未能查到相关数据！")
            }
          }).catch(()=>{
            this.isLoading=false
          })
        }
      }).catch(()=>{
        this.isLoading=false
      })
    },
    formatTime(timestmp){
      return dayjs(timestmp).format("YYYY-MM-DD")
    }
  }
}
</script>

<style type="text/css" scoped>
.devicecard{
  padding: 0.8em 0.5em;
  text-align: left;
  background: #fff;
  line-height: 1.4em;
  border-bottom: 1px solid #ebedf0;
}
.devicecard>div{
  display: flex;
}
.devicecard>div>span{
  flex: 1;
  text-align: right;
}
.devicecard .mlabel{
  font-weight: 700;
  flex: 0 1 auto;
  width: 6em;
  text-align: left;
}
</style>
